import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { Button, Modal } from 'antd';

function LogoutDialogComponent({ open, onClose, onConfirm }) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Are you sure you want to Log-out?"
      footer={[
        <Button key="cancel" type="primary" onClick={onClose}>Cancel</Button>,
        <Button key="confirm" danger type="primary" onClick={onConfirm} autoFocus>Confirm</Button>,
      ]}
    />
  );
}

const useLogout = () => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);
  const [openDialogue, setOpenDialogue] = useState(false);

  const handledialogueOpen = () => setOpenDialogue(true);
  const handledialogueClose = () => setOpenDialogue(false);

  const logout_now = () => {
    logout();
    setOpenDialogue(false);
    navigate('/');
  };

  const LogoutDialog = (
    <LogoutDialogComponent
      open={openDialogue}
      onClose={handledialogueClose}
      onConfirm={logout_now}
    />
  );

  return {
    handledialogueOpen,
    LogoutDialog,
  };
};

export default useLogout;
